var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("人工服务热线：400-107-8586")])
}
var staticRenderFns = []

export { render, staticRenderFns }